$('.feature-slider').slick({
    dots: false,
    infinite: true,
    speed: 600,
    arrows: true,
    slidesToShow: 5,
    autoplay: false,
    autoplaySpeed: 2000,
    slidesToScroll: 1,
    prevArrow: '<button type="button" class="slick-prev">Next</button>',
    nextArrow: '<button type="button" class="slick-next">Pre</button>',
    responsive: [{
            breakpoint: 1440,
            settings: {
                slidesToShow: 5,
                slidesToScroll: 1,
                infinite: true,
                dots: false
            }
        },{ 
            breakpoint: 1259,
            settings: {
                slidesToShow: 5,
                slidesToScroll: 1,
                infinite: true,
                dots: false
            }
        }, {
            breakpoint: 1100,
            settings: {
                slidesToShow: 4,
                slidesToScroll: 1,
                infinite: true,
                dots: false
            }
        }, 
        {
            breakpoint: 991,
            settings: {
                slidesToShow: 3,
                slidesToScroll: 1
            }
        },
        {
            breakpoint: 768,
            settings: {
                slidesToShow: 2,
                slidesToScroll: 1
            }
        },
        {
            breakpoint: 480,
            settings: {
                slidesToShow: 2,
                slidesToScroll: 1
            }
        }
        // You can unslick at a given breakpoint now by adding:
        // settings: "unslick"
        // instead of a settings object
    ]
});


$('.blog-slider').slick({
    dots: false,
    infinite: true,
    speed: 600,
    arrows: true,
    slidesToShow: 3,
    autoplay: false,
    autoplaySpeed: 2000,
    slidesToScroll: 1,
    prevArrow: '<button type="button" class="slick-prev">Next</button>',
    nextArrow: '<button type="button" class="slick-next">Pre</button>',
    responsive: [{
            breakpoint: 1440,
            settings: {
                slidesToShow: 3,
                slidesToScroll: 1,
                infinite: true,
                dots: false
            }
        },{ 
            breakpoint: 1259,
            settings: {
                slidesToShow: 3,
                slidesToScroll: 1,
                infinite: true,
                dots: false
            }
        }, {
            breakpoint: 1100,
            settings: {
                slidesToShow: 3,
                slidesToScroll: 1,
                infinite: true,
                dots: false
            }
        }, 
        {
            breakpoint: 991,
            settings: {
                slidesToShow: 2,
                slidesToScroll: 1
            }
        },
        {
            breakpoint: 768,
            settings: {
                slidesToShow: 2,
                slidesToScroll: 1
            }
        },
        {
            breakpoint: 480,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1
            }
        }
        // You can unslick at a given breakpoint now by adding:
        // settings: "unslick"
        // instead of a settings object
    ]
});
 
  


//   $(document).ready(function() {
//     var requiredAdded = false;
  
//     $('#button-line-item-property').on('click', function() {
//       setTimeout(function() {
//         if (!requiredAdded) {
//           $('#group-line-item-property .product-info__block-item input').attr('required', true);
//           requiredAdded = true;
//         } else {
//           $('#group-line-item-property .product-info__block-item input').removeAttr('required');
//           requiredAdded = false;
//         }
//       }, 500); // 500ms delay
//     });
//   });
     
//   $(document).on('click', '.custom-size > .variant-picker__option-values input', function() {
//     $('#group-line-item-property .product-info__block-item input').removeAttr('required');
//   });

  
  // When any input inside .custom-size > .variant-picker__option-values input is clicked,
  // remove .custom-size-option from the .custom-size parent
  $(document).on('click', '.custom-size > .variant-picker__option-values input', function() {
    // If the custom size variant is clicked, do not deactivate custom size mode
    if ($(this).val().toLowerCase() === 'custom size') {
      return;
    }

    $(this).closest('.custom-size').removeClass('custom-size-option');
    $('.pdp-buy-button').removeClass('pdp-buy-button-dis');
    $('#group-line-item-property .product-info__block-item input').each(function() {
        $(this).val('');
        
      });
    $('.cutom-size-error').css('display', 'none');

    $('.cutom-size-error')
      .removeClass('custom-size-error-active')
      .text('Please add custom size fields to Add to card product');

    $('#button-line-item-property').removeClass('active-button-line-item-property');
  });



  // Check if any input inside #group-line-item-property .product-info__block-item has a value,
  // then change .cutom-size-error text and add a class
  $(document).on('input change', '#group-line-item-property .product-info__block-item input', function() {
    let anyHasValue = false;
    $('#group-line-item-property .product-info__block-item input').each(function() {
      if ($(this).val().trim() !== '') {
        anyHasValue = true;
        return false; // break loop
      }
    });
    if (anyHasValue) {
      $('.pdp-buy-button').removeClass('pdp-buy-button-dis');
    }

    if (anyHasValue) {
      $('.cutom-size-error')
        .text('You Select custom size now Add to card product')
        .addClass('custom-size-error-active');
    } else {
      $('.cutom-size-error')
        .text('Please add custom size fields to Add to card product')
        .removeClass('custom-size-error-active');
    }
  });






  $(document).on('click', '#button-line-item-property', function (e) {
    e.preventDefault();
    
    const $this = $(this);
    const isActive = $this.hasClass('active-button-line-item-property');
    
    if (!isActive) {
      // Switch to Custom Size
      $this.addClass('active-button-line-item-property');
      $('.custom-size').addClass('custom-size-option');
      $('.pdp-buy-button').addClass('pdp-buy-button-dis');
      $('.cutom-size-error').css('display', 'block');
      
      const $customSizeLabel = $('.custom-size-label');
      if ($customSizeLabel.length) {
        $customSizeLabel.trigger('click');
      }
    } else {
      // Switch back to Standard Size
      $this.removeClass('active-button-line-item-property');
      $('.custom-size').removeClass('custom-size-option');
      $('.pdp-buy-button').removeClass('pdp-buy-button-dis');
      $('.cutom-size-error').css('display', 'none');
      
      // Clear custom size input values
      $('#group-line-item-property .product-info__block-item input').val('');
      $('.cutom-size-error')
        .removeClass('custom-size-error-active')
        .text('Please add custom size fields to Add to card product');
        
      const $firstSwatch = $('.custom-size .block-swatch').not('.custom-size-label').first();
      if ($firstSwatch.length) {
        $firstSwatch.trigger('click');
      }
    }
  });

  

   

  
   